import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=e3f5264a&scoped=true"
import script from "./GroupView.vue?vue&type=script&lang=js"
export * from "./GroupView.vue?vue&type=script&lang=js"
import style0 from "./GroupView.vue?vue&type=style&index=0&id=e3f5264a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f5264a",
  null
  
)

export default component.exports